import { render, staticRenderFns } from "./trim-menu.vue?vue&type=template&id=35fc938c&scoped=true&lang=pug&"
import script from "./trim-menu.vue?vue&type=script&lang=js&"
export * from "./trim-menu.vue?vue&type=script&lang=js&"
import style0 from "./trim-menu.vue?vue&type=style&index=0&id=35fc938c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc938c",
  null
  
)

export default component.exports